import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { OrSeparator, QuestionItem, QuestionList, SubQuestionItem, } from "./style";
const isSubPointQuestion = (question) => question.trim().startsWith("-");
const QuestionsAskedList = ({ questionsAsked, sectionTitle, showOrBetweenQuestions = false, }) => {
    const mainQuestionCount = questionsAsked.filter((question) => !isSubPointQuestion(question)).length;
    const shouldNumberMainQuestions = mainQuestionCount > 1;
    let mainQuestionNumber = 0;
    return (_jsx(QuestionList, { children: questionsAsked.map((question, idx) => {
            const trimmed = question.trim();
            const isSubPoint = isSubPointQuestion(question);
            const content = trimmed.replace(/^-\s*/, "");
            const key = `${sectionTitle}-${idx}`;
            if (isSubPoint) {
                return _jsx(SubQuestionItem, { children: content }, key);
            }
            mainQuestionNumber += 1;
            const hasNextMainQuestion = questionsAsked
                .slice(idx + 1)
                .some((q) => !isSubPointQuestion(q));
            return (_jsxs(React.Fragment, { children: [_jsx(QuestionItem, Object.assign({ "$number": shouldNumberMainQuestions ? mainQuestionNumber : undefined }, { children: content })), showOrBetweenQuestions && hasNextMainQuestion && (_jsx(OrSeparator, { children: "or" }))] }, key));
        }) }));
};
export default QuestionsAskedList;
